/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S6_P1Inputs */

const tr_kullanim_s6_p1 = /** @type {(inputs: Kullanim_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet bedelleri Platform üzerinde ilan edilen tarife uyarınca tahsil edilir. Ödemeler, Sipay Sanal POS altyapısı üzerinden kredi kartı veya banka kartı ile ya da Sağlayıcı'nın bildirdiği banka hesabına havale/EFT ile gerçekleştirilir; havale/EFT ile ödemede abonelik, bedelin hesaba ulaşmasının ardından aktif edilir.`)
};

const en_kullanim_s6_p1 = /** @type {(inputs: Kullanim_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service fees are collected in accordance with the tariff published on the Platform. Payments are made by credit or debit card via the Sipay Sanal POS infrastructure or by bank transfer/EFT to the bank account stated by the Provider; with bank transfer/EFT the subscription is activated once the amount has been received.`)
};

const de_kullanim_s6_p1 = /** @type {(inputs: Kullanim_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Dienstleistungsentgelte werden nach dem auf der Plattform veröffentlichten Tarif erhoben. Zahlungen erfolgen per Kredit- oder Bankkarte über die Sanal-POS-Infrastruktur von Sipay oder per Überweisung/EFT auf das vom Anbieter genannte Bankkonto; bei Überweisung/EFT wird das Abonnement nach Eingang des Betrags aktiviert.`)
};

const ru_kullanim_s6_p1 = /** @type {(inputs: Kullanim_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стоимость услуг взимается в соответствии с тарифом, опубликованным на Платформе. Оплата производится кредитной или дебетовой картой через инфраструктуру Sipay Sanal POS либо банковским переводом/EFT на указанный Поставщиком банковский счёт; при переводе/EFT подписка активируется после поступления суммы.`)
};

/**
* | output |
* | --- |
* | "Service fees are collected in accordance with the tariff published on the Platform. Payments are made by credit or debit card via the Sipay Sanal POS infrast..." |
*
* @param {Kullanim_S6_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s6_p1 = /** @type {((inputs?: Kullanim_S6_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S6_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s6_p1(inputs)
	if (locale === "de") return de_kullanim_s6_p1(inputs)
	if (locale === "ru") return ru_kullanim_s6_p1(inputs)
	return tr_kullanim_s6_p1(inputs)
});